import React from "react";
import Head from "next/head";
import { useTranslation } from "next-i18next";

// --- Constants (prevent recreation on every render) ---
const DEFAULT_TITLE = "Inter Nation English School";
const OG_IMAGE = "/lead-slider/web-uz/3.webp";

type LeadHeadProps = {
  title?: string;
  telegram_script?: boolean;
};

const LeadHead = ({
  title = DEFAULT_TITLE,
  telegram_script = false,
}: LeadHeadProps) => {
  const { t } = useTranslation();

  return (
    <Head>
      {/* Basic */}
      <title>{title}</title>
      <meta name="description" content={t("META_DESCRIPTION")} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={t("META_DESCRIPTION")} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />

      {/* Meta */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Telegram Pixel Script */}
      {telegram_script && (
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,n,s,u){
                w[n] = w[n] || function(){ (w[n].q = w[n].q || []).push(arguments) };
                var t = d.createElement(s);
                t.async = true;
                t.src = u;
                var f = d.getElementsByTagName(s)[0];
                f.parentNode.insertBefore(t, f);
              })(window, document, 'tgp', 'script', 'https://telegram.org/js/pixel.js');
              
              tgp('init', 'oyD0k9nO');
            `,
          }}
        />
      )}
    </Head>
  );
};

export default React.memo(LeadHead);
